"use client";

import Helper from "@/utils/helper";
import React, { useState } from "react";
import { usePathname, useRouter } from "next/navigation";

import { FilterProduct } from "@/types/Product.type";

import Drawer from "@/components/Drawer";
import FilterIcon from "@/components/icons/FilterIcon";
import ProductFilterSortBy from "./ProductFilterSortBy";
import SortDownIcon from "@/components/icons/SortDownIcon";
import ProductFilterSortType from "./ProductFilterSortType";

const ProductFilterMobile = ({
  onLoad,
  collectionHandle,
}: {
  onLoad?: (isLoading: boolean) => void;
  collectionHandle?: string;
}) => {
  const [opens, setOpenS] = useState({
    sortBy: false,
    sortType: false,
  });

  const router = useRouter();
  const pathname = usePathname();

  function handleFilter(filter: FilterProduct) {
    setOpenS({
      sortBy: false,
      sortType: false,
    });
    onLoad?.(true);
    const searchParams = Helper.convertFilterToParams(filter);
    router.push(`${pathname}${searchParams}`);
  }

  return (
    <>
      <div className="flex bg-gray-200 h-[40px]">
        <div
          className="w-[50%] flex justify-between items-center text-base border-r border-gray-300 text-gray-500 gap-1 px-4 py-[10px]"
          onClick={() => {
            setOpenS((pre) => {
              return { ...pre, sortBy: true };
            });
          }}
        >
          <span className="flex-1 text-base leading-[1.6] font-medium text-center">
            Sắp xếp theo
          </span>
          <SortDownIcon className="min-w-6" />
        </div>
        <div
          className="w-[50%] flex justify-between items-center text-base border-r border-gray-300 text-gray-500 gap-1 px-4 py-[10px]"
          onClick={() => {
            setOpenS((pre) => {
              return { ...pre, sortType: true };
            });
          }}
        >
          <span className="flex-1 text-base leading-[1.6] font-medium text-center">
            Bộ Lọc
          </span>
          <FilterIcon className="min-w-6" />
        </div>
      </div>

      <Drawer
        classNameHeader="mt-[30px] mb-[15px]"
        title={
          <h5 className="flex-1 h-full flex items-center font-bold justify-center text-base">
            Sắp xếp theo
          </h5>
        }
        open={opens.sortBy}
        onClose={() => {
          setOpenS((pre) => {
            return { ...pre, sortBy: false };
          });
        }}
      >
        <ProductFilterSortBy onFilter={handleFilter} />
      </Drawer>
      <Drawer
        classNameHeader="mt-[30px] mb-[15px]"
        title={
          <h5 className="flex-1 h-full flex items-center font-bold justify-center text-base">
            Sắp xếp theo
          </h5>
        }
        open={opens.sortType}
        onClose={() => {
          setOpenS((pre) => {
            return { ...pre, sortType: false };
          });
        }}
      >
        <ProductFilterSortType
          onFilter={handleFilter}
          collectionHandle={collectionHandle}
        />
      </Drawer>
    </>
  );
};

export default ProductFilterMobile;
